const ChecksIcon = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'>
      <g clipPath='url(#clip0_8765_53626)'>
        <path
          d='M1.25 10.1789L4.25 13.125L11.25 6.25'
          stroke='#735BF2'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
        <path
          d='M9.8418 11.25L11.7512 13.125L18.7512 6.25'
          stroke='#735BF2'
          strokeWidth='1.25'
          strokeLinecap='round'
          strokeLinejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_8765_53626'>
          <rect width='20' height='20' fill='white' />
        </clipPath>
      </defs>
    </svg>
  )
}

export default ChecksIcon
